import { ContentWrapper } from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import {
  workorderComplementColor,
  WorkOrderComplementStatus,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useWindowSize } from '@/hooks';
import { Col, Divider, Row } from 'antd';
import WorkOrdersOpenMonth from './WorkOrdersOpenMonth';
import WorkOrdersOpenTotal from './WorkOrdersOpenTotal';

interface Props {
  workOrderValueOpenMonth?: number;
  workOrderValueTotal?: number;
}

function WorkOrderOpen({
  workOrderValueOpenMonth,
  workOrderValueTotal,
}: Props) {
  const { width } = useWindowSize();

  return (
    <ContentWrapper
      style={{ padding: '16px' }}
      extraStyle={{ top: '10px', right: '8px' }}
    >
      <StatusTag
        size="lg"
        label="Aberto"
        color={workorderComplementColor[WorkOrderComplementStatus.Open]}
      />

      <Row gutter={[24, 12]} style={{ marginTop: 8 }}>
        <Col span={width < 1707 ? 24 : undefined}>
          <WorkOrdersOpenMonth value={workOrderValueOpenMonth || 0} />
        </Col>

        <Col span={width < 1707 ? 24 : undefined}>
          <Divider
            type={width >= 1707 ? 'vertical' : 'horizontal'}
            style={{ height: '100%', margin: 0 }}
          />
        </Col>

        <Col span={width < 1707 ? 24 : undefined}>
          <WorkOrdersOpenTotal value={workOrderValueTotal || 0} />
        </Col>
      </Row>
    </ContentWrapper>
  );
}

export default WorkOrderOpen;
